<template>
  <div class="trainingRecord">
    <div class="imgs">
      <div class="case">
        <div class="infore">
          <span class="tag inline">姓名：</span>
          <div  class="inline not">{{imgInfo.empName}}</div>
        </div>
        <span class="tag inline">个人照片：</span>
        <div v-if="!imgInfo.empHeadportrait" class="inline not">暂无个人照片</div>
        <img v-else :src="imgInfo.empHeadportrait" alt>
      </div>
      <div class="case">
        <div class="infore">
          <span class="tag inline">身份证号码：</span>
          <div class="inline not">{{imgInfo.empIdcard}}</div>
        </div>
        <span class="tag inline">身份证人像面：</span>
        <div v-if="!imgInfo.empIdcardFront" class="inline not">暂无身份证人像面</div>
        <img v-else :src="imgInfo.empIdcardFront" alt>
      </div>
      <div class="case">
         <div class="infore inforeNodata">
        </div>
        <span class="tag inline">身份证国徽面：</span>
        <div v-if="!imgInfo.empIdcardNegative" class="inline not">暂无身份证国徽面</div>
        <img v-else :src="imgInfo.empIdcardNegative" alt>
      </div>
    </div>
    <el-table :data="photoInfo" border max-height="660" highlight-current-row>
      <el-table-column type="index" width="50" label="序号" />
      <el-table-column prop="courseName" label="课程名称"  min-width="120" />
      <el-table-column prop="sectionName" label="章节名称"  min-width="120" />
      <el-table-column prop="courseOver" label="学习状态" width="100" />
      <!-- <el-table-column label="习题完成状态" width="120">
        <template slot-scope="scope">
          <span :class="scope.row.exerciseFlagName =='已完成'?'isActive':''">
            {{ scope.row.exerciseFlagName }}
          </span>
        </template>
      </el-table-column> -->
      <el-table-column prop="courseStudyEnd" label="完成时间" width="180" />
      <el-table-column prop="photoUrl" label="实时拍摄照片" width="380">
        <template slot-scope="scope">
          <div style="overflow-x:auto">
            <img
            v-for="(item, index) in scope.row.photoList"
            :key="index"
            :src="item.photoUrl"
            alt
            style="width:100px;display:inline-block;margin-right:10px;margin-bottom:10px"
          >
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column label="审核状态" width="160">
        <template slot-scope="scope">
          <el-tooltip placement="top" :disabled="scope.row.invalid !== 1">
            <div slot="content">{{ scope.row.invalidComment }}</div>
            <el-button
              v-if="scope.row.state == '通过'"
              type="text"
              style="color: #67c23a"
            >{{ scope.row.state }}</el-button>
            <el-button
              v-else-if="scope.row.state == '不通过'"
              type="text"
              style="color: #f56c6c"
            >{{ scope.row.state }}</el-button>
            <el-button v-else type="text" style="color: #409eff">{{ scope.row.state }}</el-button>
          </el-tooltip>
        </template>
      </el-table-column> -->
      <!-- <el-table-column prop="invalidComment" label="审核意见" min-width="100" show-overflow-tooltip /> -->
    </el-table>
  </div>
</template>

<script>
import {
  employeeDetailIgnore,
  getEmployeeStudyListIgnore
} from '@/apiCloud/linkUrl'
import CryptoJS from 'crypto-js';

const key = CryptoJS.enc.Utf8.parse('mysecretkey12345');
const iv = CryptoJS.enc.Utf8.parse('myivparameter123');
  export default ({
      data() {
      return {
        imgInfo:{},
        photoInfo: [],
        courseId:this.$route.query.courseId,
        empId:this.$route.query.empId,
        regId:this.$route.query.regId,
        strCourseId:'',
        strEmpId:'',
        strRegId:''
        // courseId:250,
        // empId:292471,
        // regId:255212
      }
    },
    mounted(){
      let data ={
        empId:this.strEmpId
      }
      employeeDetailIgnore(data).then(res => {
        if(res.code ==200){
          this.imgInfo = res.data
          let data ={
            courseId:this.strCourseId,
            empId:this.strEmpId,
            regId:this.strRegId
          }
          getEmployeeStudyListIgnore(data).then(res => {
          if(res.code ==200){
              this.photoInfo = res.data
              this.photoInfo.sectionName
              for (let i = 0; i < this.photoInfo.length; i++) {
                  this.photoInfo[i].sectionName = this.photoInfo[i].cateName + '——' + this.photoInfo[i].ccName
                  this.photoInfo[i].state = this.photoInfo[i].invalid === 0 ? '通过' : this.photoInfo[i].invalid === 1 ? '不通过' : '待审核'
                  this.photoInfo[i].courseOver = this.photoInfo[i].courseOver === 0 ? '学习中' : this.photoInfo[i].courseOver === 1 ? '已学完' : '待学习'
                  this.photoInfo[i].exerciseFlagName = this.photoInfo[i].exerciseFlag === 0 ? '未完成' : this.photoInfo[i].exerciseFlag === 1 ? '已完成' : ''
                }
            }
         })
        }
        })
    },
    created(){
      this.strCourseId =this.decryptAES(this.decodeUrl(this.courseId))
      this.strEmpId = this.decryptAES(this.decodeUrl(this.empId))
      this.strRegId = this.decryptAES(this.decodeUrl(this.regId))
    },
    methods:{
      // AES 加密
    encryptAES(plainText) {
      const cipherText = CryptoJS.AES.encrypt(plainText, key, {
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      return cipherText.toString();
    },
    // AES 解密
    decryptAES(cipherText) {
      const decryptedText = CryptoJS.AES.decrypt(cipherText, key, {
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      return decryptedText.toString(CryptoJS.enc.Utf8);
    },
    decodeUrl(url) {
      let decodedUrl = decodeURIComponent(url);
      // 还原空格
      decodedUrl = decodedUrl.replace(/\+/g, ' ');
      // 还原等号
      decodedUrl = decodedUrl.replace(/%3D/g, '=');
      // 还原加号
      decodedUrl = decodedUrl.replace(/%2B/g, '+');
      // 还原斜杠
      decodedUrl = decodedUrl.replace(/%2F/g, '/');
      // 还原问号
      decodedUrl = decodedUrl.replace(/%3F/g, '?');
      // 还原井号
      decodedUrl = decodedUrl.replace(/%23/g, '#');
      // 还原百分号
      decodedUrl = decodedUrl.replace(/%25/g, '%');
      //空格还原加号
      decodedUrl = decodedUrl.replace(/\s/g, '+');
      return decodedUrl;
    }
    }
  })

  </script>
    
 <style>
 .trainingRecord{
  padding:20px;
 }
 .imgs.Infor{
  text-align: left;
 }
  .imgs {
      margin-bottom: 20px;
      display: flex;
      justify-content: space-around;
      
    }
    .imgs .tag {
      width: 120px;
      text-align: right;
      font-size: 16px;
      display: inline-block;
      vertical-align: top;
    }
    .imgs .case  img {
      max-height: 140px;
      width: auto;
    }
    .imgs .tag .not {
      margin-left: 10px;
      color: rgb(136, 133, 133);
    }
    .noActive {
      color: #f40;
    }
    .isActive {
      color: green;
    }
    .imgs .case .infore{
      margin-bottom: 30px;
    }
    .imgs .case .infore.inforeNodata{
      margin-bottom: 55px;
    }
  </style>


// WEBPACK FOOTER //
// src/pages/linkUrl.vue